import Thumbnail from '../../Thumbnail/Thumbnail';

import ArticleIntroView from './ArticleIntroView';
import AuthorIntro from './AuthorIntro';
import CoverPhoto from './CoverPhoto';

export { ArticleIntroView, AuthorIntro, CoverPhoto, Thumbnail };

export type { PropTypes as ThumbnailPropTypes } from '../../Thumbnail/Thumbnail';
